module.exports = __webpack_public_path__ + "static/media/Low gain (PhD Z V2) VR.3832f38.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/amp/Low gain (PhD Z V2) VR.mp3
// module id = C26/
// module chunks = 13